import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Receipt } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ReceiptsCard = ({ planExpiresAt }) => {
  const [receipts, setReceipts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/payments/mine`, { withCredentials: true }).then(({ data }) => setReceipts(data)).catch(() => setReceipts([]));
  }, []);

  if (!receipts || receipts.length === 0) return null;
  const until = planExpiresAt ? new Date(planExpiresAt).toLocaleDateString(undefined, { dateStyle: 'long' }) : null;

  return (
    <Card className="border-amber-100 shadow-sm" data-testid="receipts-card">
      <CardHeader>
        <CardTitle className="font-display text-xl flex items-center text-amber-950">
          <Receipt className="h-5 w-5 mr-2 text-amber-700" />
          Your receipts
        </CardTitle>
        <CardDescription data-testid="receipts-until">{until ? `Writer plan runs until ${until}` : 'Past purchases'}</CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="divide-y divide-amber-100" data-testid="receipts-list">
          {receipts.map((r) => (
            <li key={r.id} className="py-3 flex items-center justify-between gap-4 text-sm" data-testid={`receipt-${r.id}`}>
              <div>
                <p className="font-medium text-amber-950">Writer plan · {r.plan}</p>
                <p className="text-xs text-amber-800/60">
                  {new Date(r.paid_at).toLocaleDateString(undefined, { dateStyle: 'medium' })} · PayPal order {r.order_id}
                </p>
              </div>
              <span className="font-display font-bold text-amber-950 whitespace-nowrap">${r.amount} {r.currency}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
